import { useTypedTranslationFunction } from 'hooks/typescript/UseTypedTranslationFunction';
import { useDomainConfig } from 'hooks/useDomainConfig';
import { ProductPriceType } from 'types/price';

type PromotionDurationType = 'from' | 'to';

interface PromotionDurationProps {
    price: ProductPriceType;
}

export const PromotionDuration = ({ price }: PromotionDurationProps) => {
    const testIdentifier = 'pages-productdetail-addtocart-promotionduration';
    const allowedDomains: number[] = [12];

    const t = useTypedTranslationFunction();
    const domainConfig = useDomainConfig();

    const getFormattedDate = (type: PromotionDurationType, date: Date | null) => {
        const baseDate = new Date();

        const finalDate = date
            ? date
            : type === 'from'
            ? new Date(baseDate.getFullYear(), baseDate.getMonth(), 1)
            : new Date(baseDate.getFullYear(), baseDate.getMonth() + 1, 0);

        return finalDate.toLocaleDateString(
            domainConfig.defaultLocaleIdentifier,
            date
                ? {
                      timeZone: 'UTC',
                  }
                : {},
        );
    };

    if (!allowedDomains.includes(domainConfig.domainId)) {
        return <></>;
    }

    return (
        <div className="text-small leading-6" data-testid={testIdentifier}>
            {t(`Promotion valid from {{ validFrom }} to {{ validTo }}`, {
                validFrom: getFormattedDate('from', price.validFrom),
                validTo: getFormattedDate('to', price.validTo),
            })}
        </div>
    );
};
